import t from "@emotion/styled/base";
import { Text as e } from "../../../Text/index.js";
function d() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const i = /* @__PURE__ */ t(e, process.env.NODE_ENV === "production" ? {
  target: "e7mdqa70"
} : {
  target: "e7mdqa70",
  label: "UnitText"
})(process.env.NODE_ENV === "production" ? {
  name: "1ud9i0q",
  styles: "padding:8px 0"
} : {
  name: "1ud9i0q",
  styles: "padding:8px 0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvVGV4dElucHV0L3N1YkNvbXBvbmVudHMvVW5pdExhYmVsL1VuaXRMYWJlbC5zdHlsZWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSW9DIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvVGV4dElucHV0L3N1YkNvbXBvbmVudHMvVW5pdExhYmVsL1VuaXRMYWJlbC5zdHlsZWQudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IFRleHQgfSBmcm9tICcuLi8uLi8uLi9UZXh0JztcblxuZXhwb3J0IGNvbnN0IFVuaXRUZXh0ID0gc3R5bGVkKFRleHQpYFxuICAgIHBhZGRpbmc6IDhweCAwO1xuYDtcbiJdfQ== */",
  toString: d
});
export {
  i as UnitText
};
